import { Socials } from '../components'

export function SocialsContainer({ children }) {
  return(
    <Socials>
      <Socials.List>
        <Socials.Item href="https://github.com/Aldothedev" src='./icons/github.svg'/>
        <Socials.Item href="https://twitter.com/aldothedev_" src='./icons/twitter.svg'/>
        <Socials.Item href="https://www.linkedin.com/in/aldothedev/" src='./icons/linkedin.svg'/>
      </Socials.List>
    </Socials>
  )
}